module.exports = __webpack_public_path__ + "img/150.b5a3d26d.png";